import http from '../../http-common'
import { authStore } from '../../stores/auth'
import { devLog } from '@/services/logger'

const summarizeData = (data: unknown): string | string[] => {
  if (Array.isArray(data)) {
    return `Array(${data.length})`
  }

  if (data && typeof data === 'object') {
    return Object.keys(data as Record<string, unknown>)
  }

  if (typeof data === 'string') {
    return `String(length: ${data.length})`
  }

  if (data === null || data === undefined) {
    return 'No data'
  }

  return typeof data
}

class AuthDataService {
  async login(data: any): Promise<any> {
    devLog('🌐 AuthService.login called with username')

    const auth = authStore()
    // Limpa dados de sessão anterior antes de novo login
    auth.removeToken()

    const response = await http.post('/token/', data, {
      withCredentials: true,
    })

    devLog('🎫 Token response summary:', {
      hasAccess: !!response.data.access,
      hasRefresh: !!response.data.refresh,
    })
    devLog('🎫 Token payload keys:', summarizeData(response.data))

    const { access, refresh } = response.data
    auth.updateToken(access, refresh, new Date().toISOString())

    devLog('💾 Tokens saved to auth store')

    return response
  }

  me(companyId?: string | number): Promise<any> {
    devLog('👤 AuthService.me called')
    const config: any = {}
    if (companyId) {
      config.headers = { 'X-Company-ID': String(companyId) }
    }
    return http.get('/me', config)
  }

  verifyMail(token: string): Promise<any> {
    return http.get('/verify-email/' + token)
  }

  confirmContract(): Promise<any> {
    return http.post('/empresa/confirm-contract')
  }

  sendEmailForPasswordRecovery(email: string): Promise<any> {
    devLog('✉️ AuthService.sendEmailForPasswordRecovery called with email:', email)
    return http.post('/recover-password/', { email })
  }

  resetPassword(data: any): Promise<any> {
    devLog('🔒 AuthService.resetPassword called')
    return http.post('/reset-password/', data)
  }
}

export default new AuthDataService()
